/* Product benefit tabs (moved from sections/product-benefits-section.liquid). */
    (() => {
      const initializeProductBenefitTabs = (sectionElement) => {
        if (
          !sectionElement ||
          sectionElement.dataset.benefitTabsInitialized === 'true'
        ) {
          return;
        }

        sectionElement.dataset.benefitTabsInitialized = 'true';

        const tabButtons = sectionElement.querySelectorAll(
          '[data-benefit-tab-button]'
        );

        const tabPanels = sectionElement.querySelectorAll(
          '[data-benefit-tab-panel]'
        );

        const activateTab = (selectedTab) => {
          tabButtons.forEach((button) => {
            const isActive =
              button.dataset.benefitTabButton === selectedTab;

            button.classList.toggle('is-active', isActive);
            button.setAttribute(
              'aria-selected',
              isActive ? 'true' : 'false'
            );
          });

          tabPanels.forEach((panel) => {
            const isActive =
              panel.dataset.benefitTabPanel === selectedTab;

            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
          });
        };

        tabButtons.forEach((button) => {
          button.addEventListener('click', () => {
            activateTab(button.dataset.benefitTabButton);
          });
        });
      };

      document
        .querySelectorAll('[data-product-benefit-tabs]')
        .forEach(initializeProductBenefitTabs);

      document.addEventListener('shopify:section:load', (event) => {
        const loadedSection = event.target.querySelector(
          '[data-product-benefit-tabs]'
        );

        initializeProductBenefitTabs(loadedSection);
      });
    })();
